import type { ReactNode } from "react";

import { Card } from "./Card";

type Props = {
  title: string;
  /** One or two sentences saying what happened and what to do. */
  children: ReactNode;
  /** The way out: a link back, a sign-out. */
  action?: ReactNode;
  className?: string;
};

/**
 * A page that is only a message — not found, not authorized, failed to start — drawn as the
 * eval dashboard's not-found card, so every dead end in the app looks the same.
 */
export default function NoticeCard({ title, children, action, className }: Props) {
  return (
    <Card className={className}>
      <div className="px-7 py-6" role="status">
        <h1 className="text-section text-ink">{title}</h1>
        <div className="mt-1.5 text-body-sm text-ink-2">{children}</div>
        {action !== undefined ? <div className="mt-4">{action}</div> : null}
      </div>
    </Card>
  );
}
